import { render, staticRenderFns } from "./AppItemColorSelector.vue?vue&type=template&id=6afa68c0&scoped=true&"
import script from "./AppItemColorSelector.vue?vue&type=script&lang=ts&"
export * from "./AppItemColorSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppItemColorSelector.vue?vue&type=style&index=0&id=6afa68c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afa68c0",
  null
  
)

export default component.exports